import {TypeMagasinEnum} from "@enums/typeMagasin.enum";

export enum StoreCountryEnum {
    FRANCE = 'FRANCE',
    LUXEMBOURG = "LUXEMBOURG",
    ESPAGNE = 'ESPAGNE',
    PORTUGAL = 'PORTUGAL',
    SLOVENIE = 'SLOVÉNIE',
    ANDORRE = 'ANDORRE',
}

export class StoreCountryUtils {
    static getAllCountries(): StoreCountryEnum[] {
        return Object.values(StoreCountryEnum);
    }
}
